<div *ngIf="visible" class="popup-overlay" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <div class="popup-header-title">
        <span class="popup-title-icon"><i class="fas fa-history"></i></span>
        <div class="popup-title-text">
          <h4 class="popup-title">Pratiche danno del collo</h4>
          <p class="popup-subtitle">
            Collo <span class="claim-code">{{ parcelCode || '-' }}</span>
            · {{ claims.length }} {{ claims.length === 1 ? 'pratica' : 'pratiche' }}
            <ng-container *ngIf="claims.length > 0"> · {{ openCount }} {{ openCount === 1 ? 'aperta' : 'aperte' }}</ng-container>
          </p>
        </div>
      </div>
      <button type="button" class="btn-close" (click)="close()" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body popup-body--flush">
      <div class="types-empty" *ngIf="claims.length === 0">
        <i class="fas fa-folder-open fa-2x mb-2"></i>
        <div>Nessuna pratica danno per questo collo.</div>
      </div>

      <table class="table types-table claims-table" *ngIf="claims.length > 0">
        <thead>
          <tr>
            <th>Pratica</th>
            <th>Stato</th>
            <th>Gravità</th>
            <th>Tipo</th>
            <th class="text-center">Priorità</th>
            <th>Aperta il</th>
            <th>Chiusa il</th>
            <th>Esito</th>
            <th>Assegnata a</th>
            <th class="text-end">Azione</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let claim of sortedClaims; trackBy: trackByClaim"
              class="claims-row" [class.claims-row--closed]="isClosed(claim)"
              (click)="open(claim)">
            <td><span class="type-code">{{ claim.damageCode || ('#' + claim.damageId) }}</span></td>
            <td>
              <span class="claim-pill" [ngClass]="statusClass(claim.damageStatus)">
                {{ claim.damageStatus ? ('DAMAGES.STATUS.' + claim.damageStatus | translate) : '-' }}
              </span>
            </td>
            <td>
              <span class="claim-pill" [ngClass]="severityClass(claim.damageSeverity)">
                {{ claim.damageSeverity ? ('DAMAGES.SEVERITY.' + claim.damageSeverity | translate) : '-' }}
              </span>
            </td>
            <td>{{ claim.damageType ? ('DAMAGES.TYPE.' + claim.damageType | translate) : '-' }}</td>
            <td class="text-center">{{ claim.damagePriority ?? '-' }}</td>
            <td class="claims-date">{{ claim.damageOpenedAt ? (claim.damageOpenedAt | date:'dd/MM/yy HH:mm') : '-' }}</td>
            <td class="claims-date">{{ claim.damageClosedAt ? (claim.damageClosedAt | date:'dd/MM/yy HH:mm') : '-' }}</td>
            <td>{{ claim.damageCloseOutcome || '-' }}</td>
            <td>{{ claim.damageAssignedTo || '-' }}</td>
            <td class="text-end">
              <button type="button" class="row-action-btn" (click)="$event.stopPropagation(); open(claim)"
                      [title]="'Apri la pratica danno ' + (claim.damageCode || '#' + claim.damageId)">
                <i class="fas fa-folder-open"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="popup-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">Chiudi</button>
    </div>

  </div>
</div>
